import { useEffect } from 'react';

const APP_NAME = 'Ai Skills Matrix';

/**
 * Sets the document title for a page.
 *
 * @param {string} title - The page title. If provided, renders as "Title | Ai Skills Matrix"
 *                         If empty/null, renders as just "Ai Skills Matrix"
 *
 * @example
 * // Static title
 * usePageTitle('Dashboard');  // → "Dashboard | Ai Skills Matrix"
 *
 * @example
 * // Dynamic title with space name
 * usePageTitle(space?.name ? `${space.name} - Matrix` : 'Matrix');
 *
 * @example
 * // No title (app name only)
 * usePageTitle();  // → "Ai Skills Matrix"
 */
export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;
  }, [title]);
}

export default usePageTitle;
